/**
 * 教师端静态按钮权限兜底
 * 优先使用 auth/info 返回的 permissions；为空时用本列表
 */
export const TEACHER_STATIC_PERMISSIONS = ["*:*:*"];

export default TEACHER_STATIC_PERMISSIONS;



// WEBPACK FOOTER //
// ./src/config/teacherStaticPermissions.js